module.exports = __webpack_public_path__ + "media/enter.95ec9f2e.wav";